import { environment } from "../../../../../environments/environment";

const cmsbase_url = environment.CMSURL_IMG
export const REQUEST_FOR_APPROVALS_DATA = {
  "status": "S_T_21001",
  "message": "Tickets retrieved successfully",
  "redirectionCode": null,
  "data": [
      {
          "appName": "Attendance Request",
          "appUrl": "https://myts.ltts.com/AttendanceCalendar",
          "categoryName": "Attendance",
          "tickets": [
              {
                  "employeeName": "Nivedita Goyal",
                  "employeeId": "40032034",
                  "requests": [
                      {
                          "date": "16-09-2024",
                          "description": "WFH"
                      }
                  ],
                  "categoryName": "Attendance",
                  "appUrl": "https://myts.ltts.com/AttendanceCalendar"
              },
              {
                  "employeeName": "Kaushik Pal",
                  "employeeId": "20123683",
                  "requests": [
                      {
                          "date": "17-09-2024",
                          "description": "WFH"
                      }
                  ],
                  "categoryName": "Attendance",
                  "appUrl": "https://myts.ltts.com/AttendanceCalendar"
              },
              {
                  "employeeName": "Bikash Ranjan Jena",
                  "employeeId": "40026348",
                  "requests": [
                      {
                          "date": "17-09-2024",
                          "description": "WFH"
                      }
                  ],
                  "categoryName": "Attendance",
                  "appUrl": "https://myts.ltts.com/AttendanceCalendar"
              }
          ],
          "totalTicketsCount": 3
      },
      {
          "appName": "Car Request",
          "appUrl": "https://myts.ltts.com/CarPortal/CarRequest",
          "categoryName": "Car",
          "tickets": [],
          "totalTicketsCount": 0
      },
      {
          "appName": "Accommodation Request",
          "appUrl": "https://myts.ltts.com/Accomodation/AccommodationNewRequest/Index",
          "categoryName": "Accommodation",
          "tickets": [
              {
                  "requestID": 45589,
                  "requestorPsNo": "20123683",
                  "requestorFullName": "M LOGESH",
                  "emailid": "Kaushik.Pal@ltts.com",
                  "mobileNo": "9566335664",
                  "fromDate": "05-04-2024",
                  "toDate": "06-04-2024",
                  "location": "Chennai",
                  "purpose": "To attend Training / events/seminars",
                  "createdBy": "40031878",
                  "grade": "LTTS-4",
                  "bookedForContactNo": "",
                  "bookedForEmailId": ""
              },
              {
                  "requestID": 45758,
                  "requestorPsNo": "20123683",
                  "requestorFullName": "GAJJALA DEEPTHI",
                  "emailid": "Kaushik.Pal@ltts.com",
                  "mobileNo": "7997516474",
                  "fromDate": "06-05-2024",
                  "toDate": "08-05-2024",
                  "location": "Mysore",
                  "purpose": "To attend Client meeting/site visit",
                  "createdBy": "40019845",
                  "grade": "LTTS-3",
                  "bookedForContactNo": "",
                  "bookedForEmailId": ""
              },
              {
                  "requestID": 45590,
                  "requestorPsNo": "20123683",
                  "requestorFullName": "MERIN KUMAR LOGANATHAN",
                  "emailid": "Kaushik.Pal@ltts.com",
                  "mobileNo": "6379547477",
                  "fromDate": "05-04-2024",
                  "toDate": "06-04-2024",
                  "location": "Chennai",
                  "purpose": "To attend Training / events/seminars",
                  "createdBy": "40033346",
                  "grade": "LTTS-3",
                  "bookedForContactNo": "",
                  "bookedForEmailId": ""
              },
              {
                  "requestID": 46070,
                  "requestorPsNo": "20123683",
                  "requestorFullName": "SURISETTI BHANU PRAKASH",
                  "emailid": "Kaushik.Pal@ltts.com",
                  "mobileNo": "7702018129",
                  "fromDate": "28-04-2024",
                  "toDate": "11-05-2024",
                  "location": "Mysore",
                  "purpose": "Transfer",
                  "createdBy": "40041694",
                  "grade": "LTTS-2",
                  "bookedForContactNo": "",
                  "bookedForEmailId": ""
              },
              {
                  "requestID": 46071,
                  "requestorPsNo": "20123683",
                  "requestorFullName": "SURISETTI BHANU PRAKASH",
                  "emailid": "Kaushik.Pal@ltts.com",
                  "mobileNo": "7702018129",
                  "fromDate": "28-04-2024",
                  "toDate": "11-05-2024",
                  "location": "Mysore",
                  "purpose": "Transfer",
                  "createdBy": "40041694",
                  "grade": "LTTS-2",
                  "bookedForContactNo": "",
                  "bookedForEmailId": ""
              },
              {
                  "requestID": 45589,
                  "requestorPsNo": "955780",
                  "requestorFullName": "M LOGESH",
                  "emailid": "Shobha.S@Ltts.com",
                  "mobileNo": "9566335664",
                  "fromDate": "05-04-2024",
                  "toDate": "06-04-2024",
                  "location": "Chennai",
                  "purpose": "To attend Training / events/seminars",
                  "createdBy": "40031878",
                  "grade": "LTTS-4",
                  "bookedForContactNo": "",
                  "bookedForEmailId": ""
              },
              {
                  "requestID": 45590,
                  "requestorPsNo": "40026348",
                  "requestorFullName": "MERIN KUMAR LOGANATHAN",
                  "emailid": "Bikash.Jena@Ltts.com",
                  "mobileNo": "6379547477",
                  "fromDate": "05-04-2024",
                  "toDate": "06-04-2024",
                  "location": "Chennai",
                  "purpose": "To attend Training / events/seminars",
                  "createdBy": "40033346",
                  "grade": "LTTS-3",
                  "bookedForContactNo": "",
                  "bookedForEmailId": ""
              },
              {
                  "requestID": 46070,
                  "requestorPsNo": "40026348",
                  "requestorFullName": "SURISETTI BHANU PRAKASH",
                  "emailid": "Bikash.Jena@Ltts.com",
                  "mobileNo": "7702018129",
                  "fromDate": "28-04-2024",
                  "toDate": "11-05-2024",
                  "location": "Mysore",
                  "purpose": "Transfer",
                  "createdBy": "40041694",
                  "grade": "LTTS-2",
                  "bookedForContactNo": "",
                  "bookedForEmailId": ""
              },
              {
                  "requestID": 46071,
                  "requestorPsNo": "40026348",
                  "requestorFullName": "SURISETTI BHANU PRAKASH",
                  "emailid": "Bikash.Jena@Ltts.com",
                  "mobileNo": "7702018129",
                  "fromDate": "28-04-2024",
                  "toDate": "11-05-2024",
                  "location": "Mysore",
                  "purpose": "Transfer",
                  "createdBy": "40041694",
                  "grade": "LTTS-2",
                  "bookedForContactNo": "",
                  "bookedForEmailId": ""
              },
              {
                  "requestID": 45758,
                  "requestorPsNo": "955780",
                  "requestorFullName": "GAJJALA DEEPTHI",
                  "emailid": "Shobha.S@Ltts.com",
                  "mobileNo": "7997516474",
                  "fromDate": "06-05-2024",
                  "toDate": "08-05-2024",
                  "location": "Mysore",
                  "purpose": "To attend Client meeting/site visit",
                  "createdBy": "40019845",
                  "grade": "LTTS-3",
                  "bookedForContactNo": "",
                  "bookedForEmailId": ""
              },
              {
                  "requestID": 45590,
                  "requestorPsNo": "955780",
                  "requestorFullName": "MERIN KUMAR LOGANATHAN",
                  "emailid": "Shobha.S@Ltts.com",
                  "mobileNo": "6379547477",
                  "fromDate": "05-04-2024",
                  "toDate": "06-04-2024",
                  "location": "Chennai",
                  "purpose": "To attend Training / events/seminars",
                  "createdBy": "40033346",
                  "grade": "LTTS-3",
                  "bookedForContactNo": "",
                  "bookedForEmailId": ""
              },
              {
                  "requestID": 46070,
                  "requestorPsNo": "955780",
                  "requestorFullName": "SURISETTI BHANU PRAKASH",
                  "emailid": "Shobha.S@Ltts.com",
                  "mobileNo": "7702018129",
                  "fromDate": "28-04-2024",
                  "toDate": "11-05-2024",
                  "location": "Mysore",
                  "purpose": "Transfer",
                  "createdBy": "40041694",
                  "grade": "LTTS-2",
                  "bookedForContactNo": "",
                  "bookedForEmailId": ""
              },
              {
                  "requestID": 46071,
                  "requestorPsNo": "955780",
                  "requestorFullName": "SURISETTI BHANU PRAKASH",
                  "emailid": "Shobha.S@Ltts.com",
                  "mobileNo": "7702018129",
                  "fromDate": "28-04-2024",
                  "toDate": "11-05-2024",
                  "location": "Mysore",
                  "purpose": "Transfer",
                  "createdBy": "40041694",
                  "grade": "LTTS-2",
                  "bookedForContactNo": "",
                  "bookedForEmailId": ""
              },
              {
                  "requestID": 45589,
                  "requestorPsNo": "40026348",
                  "requestorFullName": "M LOGESH",
                  "emailid": "Bikash.Jena@Ltts.com",
                  "mobileNo": "9566335664",
                  "fromDate": "05-04-2024",
                  "toDate": "06-04-2024",
                  "location": "Chennai",
                  "purpose": "To attend Training / events/seminars",
                  "createdBy": "40031878",
                  "grade": "LTTS-4",
                  "bookedForContactNo": "",
                  "bookedForEmailId": ""
              },
              {
                  "requestID": 45758,
                  "requestorPsNo": "40026348",
                  "requestorFullName": "GAJJALA DEEPTHI",
                  "emailid": "Bikash.Jena@Ltts.com",
                  "mobileNo": "7997516474",
                  "fromDate": "06-05-2024",
                  "toDate": "08-05-2024",
                  "location": "Mysore",
                  "purpose": "To attend Client meeting/site visit",
                  "createdBy": "40019845",
                  "grade": "LTTS-3",
                  "bookedForContactNo": "",
                  "bookedForEmailId": ""
              }
          ],
          "totalTicketsCount": 15
      },
      {
          "appName": "Leave Request",
          "appUrl": "https://performancemanager10.successfactors.com/xi/ui/ect/pages/absence/timeOff.xhtml",
          "categoryName": "Leave",
          "tickets": [
              {
                  "employeeName": "Prathyusha Vl",
                  "employeeId": "163631",
                  "requests": [
                      {
                          "leaveType": "INDIA PRIVILEGE LEAVE",
                          "leaveFrom": "20-09-2024",
                          "leaveTo": "21-09-2024",
                          "leaveQuantityInDays": "2"
                      }
                  ],
                  "leaveType": "INDIA PRIVILEGE LEAVE",
                  "leaveFrom": "20-09-2024",
                  "leaveTo": "21-09-2024",
                  "leaveQuantityInDays": "2"
              }
          ],
          "totalTicketsCount": 1
      }
  ]
};

export const FEEDS_DATA = [
  {
    title: "Wellness tips for a healthier workday",
    time: "May 10, 2024",
    imgPath: cmsbase_url+"wp-content/uploads/2025/05/feed1.png",
  },
  {
    title: "New policy update: what you need to",
    time: "May 10, 2024",
    imgPath: cmsbase_url+"wp-content/uploads/2025/05/feed2.jpg",
  },
  {
    title: "Wellness tips for a healthier workday",
    time: "May 10, 2024",
    imgPath: cmsbase_url+"wp-content/uploads/2025/05/feed3.jpg",
  },
  {
    title: "Wellness tips for a healthier workday",
    time: "May 10, 2024",
    imgPath: cmsbase_url+"wp-content/uploads/2025/05/feed1.png",
  },
  {
    title: "Wellness tips for a healthier workday",
    time: "May 10, 2024",
    imgPath: cmsbase_url+"wp-content/uploads/2025/05/feed2.jpg",
  },
];

export const MY_TEAMS_DATA = {
  success: true,
  status: 200,
  message: "Team data retrieved successfully",
  data: {
    teamMembers: [
      {
        employeeId: "40031334",
        employeeName: "Anirudha Kalyanrao Khandagale",
        email: "Anirudha.Khandagale@ltts.com",
        designation: "Associate Engineer",
        businessUnit: "Business Enabling Units",
        department: "IT Own",
        contactInfo: [
          {
            phoneNumber: "8148966087",
            alternativeEmail: "anirudhakhandagale95@gmail.com",
            alternatePhoneNumber: "",
          },
        ],
        primaryLocations: [
          {
            city: "Pune",
            building: "Pune - Smartworks Baner",
            country: "IND",
            floor: "7th Floor, Smartworks-Baner",
            seat: null,
          },
        ],
        dateOfJoining: "2022-11-07T00:00:00",
        reportingTo: [
          {
            employeeId: "10009072",
            employeeName: "Dharanidharan R",
            email: "Kancharikuntla.Anilreddy@ltts.com",
            designation: "Program Manager",
            businessUnit: "Business Enabling Units",
            department: "IT Own",
          },
        ],
        workingStatus: "IN",
        skills: [
          {
            skillCategory: "Front End/ Client Applications",
            skillSubCategory: "Application Framework",
            skillsName: "Angular",
            experienceinMonth: "36",
            proficiencyLevel: "Supervised Practitioner",
          },
        ],
        visaDetails: [],
      },
      {
        employeeId: "40035182",
        employeeName: "Umme Hani",
        email: "Umme.Hani@ltts.com",
        designation: "Engineer",
        businessUnit: "Business Enabling Units",
        department: "IT Own",
        contactInfo: [
          {
            phoneNumber: "8148966087",
            alternativeEmail: "ummehani0895@gmail.com",
            alternatePhoneNumber: "",
          },
        ],
        primaryLocations: [
          {
            city: "Mysore",
            building: "Mysore - L&T Campus",
            country: "IND",
            floor: "Mysore - SEZ Unit-I (Module 8)",
            seat: null,
          },
        ],
        dateOfJoining: "2023-04-20T00:00:00",
        reportingTo: [
          {
            employeeId: "10009072",
            employeeName: "Dharanidharan R",
            email: "Kancharikuntla.Anilreddy@ltts.com",
            designation: "Program Manager",
            businessUnit: "Business Enabling Units",
            department: "IT Own",
          },
        ],
        workingStatus: "WFH",
        skills: [
          {
            skillCategory: "Front End/ Client Applications",
            skillSubCategory: "Application Framework",
            skillsName: "Angular",
            experienceinMonth: "36",
            proficiencyLevel: "Supervised Practitioner",
          },
          {
            skillCategory: "Database",
            skillSubCategory: "Database",
            skillsName: "MS SQL",
            experienceinMonth: "36",
            proficiencyLevel: "Supervised Practitioner",
          },
          {
            skillCategory: "Media Backend / Cloud",
            skillSubCategory: "Programing Language",
            skillsName: "ASP.Net",
            experienceinMonth: "48",
            proficiencyLevel: "Expert",
          },
        ],
        visaDetails: [],
      },
      {
        employeeId: "40023898",
        employeeName: "Anjali Gokulpure",
        email: "Anjali.Gokulpure@Ltts.com",
        designation: "Engineer",
        businessUnit: "Business Enabling Units",
        department: "IT Own",
        contactInfo: [
          {
            phoneNumber: "8148966087",
            alternativeEmail: "gokulpureanjali895@gmail.com",
            alternatePhoneNumber: "",
          },
        ],
        primaryLocations: [
          {
            city: "Bangalore",
            building: "Bangalore - S1",
            country: "IND",
            floor: "LTR S1-SEZ Unit - 1 (4th Floor)",
            seat: "S1-1F-WKS-A-232",
          },
        ],
        dateOfJoining: "2023-05-10T00:00:00",
        reportingTo: [
          {
            employeeId: "10009072",
            employeeName: "Dharanidharan R",
            email: "Kancharikuntla.Anilreddy@ltts.com",
            designation: "Program Manager",
            businessUnit: "Business Enabling Units",
            department: "IT Own",
          },
        ],
        workingStatus: "LEAVE",
        skills: [
          {
            skillCategory: "Software Testing",
            skillSubCategory: "Java",
            skillsName: "Core Java",
            experienceinMonth: "6",
            proficiencyLevel: "Practitioner",
          },
        ],
        visaDetails: [],
      },
      {
        employeeId: "40015472",
        employeeName: "Uppala Jyothirnaga Venkata Satya Prakash",
        email: "prakash.ujvs@ltts.com",
        designation: "Engineer",
        businessUnit: "Business Enabling Units",
        department: "IT Own",
        contactInfo: [
          {
            phoneNumber: "8148966087",
            alternativeEmail: "ujvprakash0895@gmail.com",
            alternatePhoneNumber: "",
          },
        ],
        primaryLocations: [
          {
            city: "Mysore",
            building: "Mysore - L&T Campus",
            country: "IND",
            floor: "Mysore - SEZ Unit-I (Module 8)",
            seat: "M5-00-WKS-0059",
          },
        ],
        dateOfJoining: "2022-06-07T00:00:00",
        reportingTo: [
          {
            employeeId: "10009072",
            employeeName: "Dharanidharan R",
            email: "Kancharikuntla.Anilreddy@ltts.com",
            designation: "Program Manager",
            businessUnit: "Business Enabling Units",
            department: "IT Own",
          },
        ],
        workingStatus: "TRAVEL",
        skills: [
          {
            skillCategory: null,
            skillSubCategory: null,
            skillsName: null,
            experienceinMonth: null,
            proficiencyLevel: null,
          },
        ],
        visaDetails: [],
      },


      {
        employeeId: "40015472",
        employeeName: "Alice Johnson",
        email: "prakash.ujvs@ltts.com",
        designation: "Engineer",
        businessUnit: "Business Enabling Units",
        department: "IT Own",
        contactInfo: [
          {
            phoneNumber: "8148966087",
            alternativeEmail: "ujvprakash0895@gmail.com",
            alternatePhoneNumber: "",
          },
        ],
        primaryLocations: [
          {
            city: "Mysore",
            building: "Mysore - L&T Campus",
            country: "IND",
            floor: "Mysore - SEZ Unit-I (Module 8)",
            seat: "M5-00-WKS-0059",
          },
        ],
        dateOfJoining: "2022-06-07T00:00:00",
        reportingTo: [
          {
            employeeId: "10009072",
            employeeName: "Dharanidharan R",
            email: "Kancharikuntla.Anilreddy@ltts.com",
            designation: "Program Manager",
            businessUnit: "Business Enabling Units",
            department: "IT Own",
          },
        ],
        workingStatus: "IN",
        skills: [
          {
            skillCategory: null,
            skillSubCategory: null,
            skillsName: null,
            experienceinMonth: null,
            proficiencyLevel: null,
          },
        ],
        visaDetails: [],
      },




      {
        employeeId: "40015472",
        employeeName: "Dan Ban",
        email: "prakash.ujvs@ltts.com",
        designation: "Engineer",
        businessUnit: "Business Enabling Units",
        department: "IT Own",
        contactInfo: [
          {
            phoneNumber: "8148966087",
            alternativeEmail: "ujvprakash0895@gmail.com",
            alternatePhoneNumber: "",
          },
        ],
        primaryLocations: [
          {
            city: "Mysore",
            building: "Mysore - L&T Campus",
            country: "IND",
            floor: "Mysore - SEZ Unit-I (Module 8)",
            seat: "M5-00-WKS-0059",
          },
        ],
        dateOfJoining: "2022-06-07T00:00:00",
        reportingTo: [
          {
            employeeId: "40026165",
            employeeName: "Kancharikuntla Anilreddy",
            email: "Kancharikuntla.Anilreddy@ltts.com",
            designation: "Tech Lead",
            businessUnit: "Business Enabling Units",
            department: "IT Own",
          },
        ],
        workingStatus: "WFH",
        skills: [
          {
            skillCategory: null,
            skillSubCategory: null,
            skillsName: null,
            experienceinMonth: null,
            proficiencyLevel: null,
          },
        ],
        visaDetails: [],
      },


      {
        employeeId: "40015472",
        employeeName: "Uppala Jyothirnaga Venkata Satya Prakash",
        email: "prakash.ujvs@ltts.com",
        designation: "Engineer",
        businessUnit: "Business Enabling Units",
        department: "IT Own",
        contactInfo: [
          {
            phoneNumber: "8148966087",
            alternativeEmail: "ujvprakash0895@gmail.com",
            alternatePhoneNumber: "",
          },
        ],
        primaryLocations: [
          {
            city: "Mysore",
            building: "Mysore - L&T Campus",
            country: "IND",
            floor: "Mysore - SEZ Unit-I (Module 8)",
            seat: "M5-00-WKS-0059",
          },
        ],
        dateOfJoining: "2022-06-07T00:00:00",
        reportingTo: [
          {
            employeeId: "10009072",
            employeeName: "Dharanidharan R",
            email: "Kancharikuntla.Anilreddy@ltts.com",
            designation: "Program Manager",
            businessUnit: "Business Enabling Units",
            department: "IT Own",
          },
        ],
        workingStatus: "LEAVE",
        skills: [
          {
            skillCategory: null,
            skillSubCategory: null,
            skillsName: null,
            experienceinMonth: null,
            proficiencyLevel: null,
          },
        ],
        visaDetails: [],
      },


      {
        employeeId: "40015472",
        employeeName: "John Doe",
        email: "prakash.ujvs@ltts.com",
        designation: "Engineer",
        businessUnit: "Business Enabling Units",
        department: "IT Own",
        contactInfo: [
          {
            phoneNumber: "8148966087",
            alternativeEmail: "ujvprakash0895@gmail.com",
            alternatePhoneNumber: "",
          },
        ],
        primaryLocations: [
          {
            city: "Mysore",
            building: "Mysore - L&T Campus",
            country: "IND",
            floor: "Mysore - SEZ Unit-I (Module 8)",
            seat: "M5-00-WKS-0059",
          },
        ],
        dateOfJoining: "2022-06-07T00:00:00",
        reportingTo: [
          {
            employeeId: "10009072",
            employeeName: "Dharanidharan R",
            email: "Kancharikuntla.Anilreddy@ltts.com",
            designation: "Program Manager",
            businessUnit: "Business Enabling Units",
            department: "IT Own",
          },
        ],
        workingStatus: "TRAVEL",
        skills: [
          {
            skillCategory: null,
            skillSubCategory: null,
            skillsName: null,
            experienceinMonth: null,
            proficiencyLevel: null,
          },
        ],
        visaDetails: [],
      },

    ],
    insights: {
      totalStrength: 8,
      in: 2,
      wfh: 2,
      travel: 2,
      leave: 2,
    },
  },
};
export const CMS_FEEDS_DATA = [
  { img: cmsbase_url+"wp-content/uploads/2025/05/Temporary-banner.png", alt: "Slide 1" },
  { img: cmsbase_url+"wp-content/uploads/2025/05/Temporary-banner.png", alt: "Slide 2" },
  { img: cmsbase_url+"wp-content/uploads/2025/05/Temporary-banner.png", alt: "Slide 3" },
]

export const ATTENDANCE_DATA = {
  "status": "S_ES_10001",
  "message": "Employee schedule fetched successfully",
  "redirectionCode": null,
  "data": [
      {
          "totalWorkingDays": 14,
          "totalPresentDays": 13,
          "totalWFH": 1,
          "totalIn": 12,
          "totalLeave": 1,
          "totalTravel": 0,
          "dailySchedule": [
              {
                  "date": "02-09-2024",
                  "day": "Mon",
                  "hours": "07:57",
                  "workingStatus": "In",
                  "description": "Present",
                  "additionalData": "null",
                  "activities": [
                      {
                          "leave": "null",
                          "travel": "null",
                          "holiday": "null",
                          "attendance": "In"
                      }
                  ]
              },
              {
                  "date": "03-09-2024",
                  "day": "Tue",
                  "hours": "08:19",
                  "workingStatus": "In",
                  "description": "Present",
                  "additionalData": "null",
                  "activities": [
                      {
                          "leave": "null",
                          "travel": "null",
                          "holiday": "null",
                          "attendance": "In"
                      }
                  ]
              },
              {
                  "date": "04-09-2024",
                  "day": "Wed",
                  "hours": "06:56",
                  "workingStatus": "In",
                  "description": "Present",
                  "additionalData": "null",
                  "activities": [
                      {
                          "leave": "null",
                          "travel": "null",
                          "holiday": "null",
                          "attendance": "In"
                      }
                  ]
              },
              {
                  "date": "05-09-2024",
                  "day": "Thu",
                  "hours": "07:47",
                  "workingStatus": "In",
                  "description": "Present",
                  "additionalData": "null",
                  "activities": [
                      {
                          "leave": "null",
                          "travel": "null",
                          "holiday": "null",
                          "attendance": "In"
                      }
                  ]
              },
              {
                  "date": "06-09-2024",
                  "day": "Fri",
                  "hours": "09:30",
                  "workingStatus": "WFH",
                  "description": "Miss Punch",
                  "additionalData": "null",
                  "activities": [
                      {
                          "leave": "null",
                          "travel": "null",
                          "holiday": "null",
                          "attendance": "WFH"
                      }
                  ]
              },
              {
                  "date": "09-09-2024",
                  "day": "Mon",
                  "hours": "08:57",
                  "workingStatus": "In",
                  "description": "Present",
                  "additionalData": "null",
                  "activities": [
                      {
                          "leave": "null",
                          "travel": "null",
                          "holiday": "null",
                          "attendance": "In"
                      }
                  ]
              },
              {
                  "date": "10-09-2024",
                  "day": "Tue",
                  "hours": "08:38",
                  "workingStatus": "In",
                  "description": "Present",
                  "additionalData": "null",
                  "activities": [
                      {
                          "leave": "null",
                          "travel": "null",
                          "holiday": "null",
                          "attendance": "In"
                      }
                  ]
              },
              {
                  "date": "11-09-2024",
                  "day": "Wed",
                  "hours": "08:57",
                  "workingStatus": "In",
                  "description": "Present",
                  "additionalData": "null",
                  "activities": [
                      {
                          "leave": "null",
                          "travel": "null",
                          "holiday": "null",
                          "attendance": "In"
                      }
                  ]
              },
              {
                  "date": "12-09-2024",
                  "day": "Thu",
                  "hours": "08:08",
                  "workingStatus": "In",
                  "description": "Present",
                  "additionalData": "null",
                  "activities": [
                      {
                          "leave": "null",
                          "travel": "null",
                          "holiday": "null",
                          "attendance": "In"
                      }
                  ]
              },
              {
                  "date": "13-09-2024",
                  "day": "Fri",
                  "hours": "",
                  "workingStatus": "Leave",
                  "description": "INDIA PRIVILEGE LEAVE",
                  "additionalData": "null",
                  "activities": [
                      {
                          "leave": "Leave",
                          "travel": "null",
                          "holiday": "null",
                          "attendance": "null"
                      }
                  ]
              },
              {
                  "date": "16-09-2024",
                  "day": "Mon",
                  "hours": "",
                  "workingStatus": "Eid-e-Milad",
                  "description": "Eid-e-Milad",
                  "additionalData": "null",
                  "activities": [
                      {
                          "leave": "null",
                          "travel": "null",
                          "holiday": "Eid-e-Milad",
                          "attendance": "Holiday"
                      }
                  ]
              },
              {
                  "date": "17-09-2024",
                  "day": "Tue",
                  "hours": "09:13",
                  "workingStatus": "In",
                  "description": "Present",
                  "additionalData": "null",
                  "activities": [
                      {
                          "leave": "null",
                          "travel": "null",
                          "holiday": "null",
                          "attendance": "In"
                      }
                  ]
              },
              {
                  "date": "18-09-2024",
                  "day": "Wed",
                  "hours": "09:03",
                  "workingStatus": "In",
                  "description": "Present",
                  "additionalData": "null",
                  "activities": [
                      {
                          "leave": "null",
                          "travel": "null",
                          "holiday": "null",
                          "attendance": "In"
                      }
                  ]
              },
              {
                  "date": "19-09-2024",
                  "day": "Thu",
                  "hours": "08:31",
                  "workingStatus": "In",
                  "description": "Present",
                  "additionalData": "null",
                  "activities": [
                      {
                          "leave": "null",
                          "travel": "null",
                          "holiday": "null",
                          "attendance": "In"
                      }
                  ]
              },
              {
                  "date": "20-09-2024",
                  "day": "Fri",
                  "hours": "00:00",
                  "workingStatus": "In",
                  "description": "Present",
                  "additionalData": "null",
                  "activities": [
                      {
                          "leave": "null",
                          "travel": "null",
                          "holiday": "null",
                          "attendance": "In"
                      }
                  ]
              }
          ]
      }
  ]
}
